// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"e1639b19","200":"6047a8ee","326":"babd7cf4","357":"2be5cccc","446":"ace5411b","508":"ef0cdae5","565":"7aff3c25","639":"7997c657","748":"80bdb6cc","766":"32fb7242","928":"eb33fbde","971":"50e9ca2b"}[chunkId] + ".chunk.js";
};